/**
 * 数据字典值翻译（中文原文 → 英文 扁平映射）
 * 按 sys_dict 字典项全量解析生成（源数据：项目根目录 .dict_values.txt）
 * - 系统固定枚举（值集封闭）录入本表；业务字典/品牌名/测试数据等不录入（英文模式下回退中文原文）
 * - 与 en-US.js、en/modules 其他词典重复的 key 不在此重复定义（沿用已有译法，避免扁平映射覆盖）
 * - 本文件由 require.context('./lang/en/modules') 自动合并，无需手动注册
 */
export default {
  // 职务职级 position_rank
  '员级': 'Staff Level',
  '助级': 'Assistant Level',
  '中级': 'Intermediate',
  '副高级': 'Deputy Senior',
  '正高级': 'Senior',
  // 表单权限策略 form_perms_type / 全局权限策略 global_perms_type
  '可编辑(未授权禁用)': 'Editable (disabled when unauthorized)',
  '可见(未授权不可见)': 'Visible (hidden when unauthorized)',
  '可编辑(未授权时禁用)': 'Editable (disabled when unauthorized)',
  '可见/可访问(授权后可见/可访问)': 'Visible/Accessible (after authorization)',
  // 紧急程度 urgent_level
  '重要': 'Important',
  // 日程计划类型 eoa_plan_type
  '日常记录': 'Daily Log',
  '本周工作': "This Week's Work",
  '下周计划': "Next Week's Plan",
  // 分类栏目类型 eoa_cms_menu_type
  '列表': 'List',
  // 数据库类型 database_type（国产库 + 兜底）
  '达梦': 'DM (Dameng)',
  '人大金仓': 'KingbaseES',
  '神通': 'Shentong',
  '其他数据库': 'Other Database',
  // Online表单业务分类 ol_form_biz_type
  '官方示例': 'Official Example',
  '流程表单': 'Process Form',
  '测试表单': 'Test Form',
  '导入表单': 'Import Form',
  // 提醒方式 remindMode / OA日程提醒方式 oa_reminder_type
  '短信提醒': 'SMS Notification',
  '邮件提醒': 'Email Notification',
  '微信提醒': 'WeChat Notification',
  // 计费类型 wt_fee_type
  '预付费': 'Prepaid',
  '后付费': 'Postpaid',
  // 运营商 mtIotType / 平台类型 platform_type
  '电信OC': 'China Telecom OC',
  '电信AEP': 'China Telecom AEP',
  // 设备类型 deviceType / wq_device_type
  '水泵': 'Water Pump',
  '水表（大口径）': 'Large-caliber Water Meter',
  '水表（居民）': 'Residential Water Meter',
  '电子阀': 'Electric Valve',
  '电磁流量计': 'Electromagnetic Flow Meter',
  '井电双控': 'Well & Power Dual Control',
  // 路线类型 routeType / 节点类型 node_type
  '厂区': 'Plant Area',
  '片区': 'District',
  '加压泵站': 'Booster Pump Station',
  '普通节点': 'Normal Node',
  '电控阀门': 'Electric Control Valve',
  '水质计': 'Water Quality Meter',
  // OA日程提醒级别 oa_reminder_level
  '重要/紧急': 'Important / Urgent',
  '重要/不紧急': 'Important / Not Urgent',
  '不重要/紧急': 'Not Important / Urgent',
  '不重要/不紧急': 'Not Important / Not Urgent',
  // OA日程提醒时间 oa_reminder_time
  '不提醒': 'No Reminder',
  '提前5分钟': '5 minutes in advance',
  '提前10分钟': '10 minutes in advance',
  '提前15分钟': '15 minutes in advance',
  '提前30分钟': '30 minutes in advance',
  '提前1小时': '1 hour in advance',
  '提前2小时': '2 hours in advance',
  // OA日历类型 oa_calendar_type
  '个人日历': 'Personal Calendar',
  '工作日历': 'Work Calendar',
  // 异常类型 account_exception
  '操作时间异常': 'Abnormal Operation Time',
  // 巡检计划类型 plan_type
  '区域巡检': 'Regional Inspection',
  '维保类型': 'Maintenance Type',
  // 评价换表类型 commentsMeterType
  '换表效率': 'Meter Replacement Efficiency',
  '换表服务态度': 'Meter Replacement Service Attitude',
  // 评价工程报装类型 commentsReportType / 评价故障报修类型 commentsRepairType
  '报装效率': 'Application Efficiency',
  '偷盗水行为': 'Water Theft',
  '报修效率': 'Repair Efficiency',
  // 计划周期 planCycle
  '单次计划': 'One-time Plan',
  '两小时一次': 'Every 2 hours',
  // 检定结果 verification_results
  '合格': 'Pass',
  '不合格': 'Fail',
  // 周期类型 customCycleType
  '单次': 'One-time',
  '季': 'Quarter',
  // 返厂原因 returned_reason
  '计量失准': 'Metering Inaccuracy',
  '电子故障': 'Electronic Failure',
  // 返厂状态 returned_state / 表具状态 meter_state
  '返厂中': 'Being Returned',
  '已修复': 'Repaired',
  '已报废': 'Scrapped',
  // 维修原因 repair_type
  '不换表': 'No Replacement',
  // 计划测点实体 planEntitiy
  '水厂设备': 'Water Plant Equipment',
  // 比较规则类型 compare_type
  '大于': 'Greater Than',
  '大于等于': 'Greater Than or Equal To',
  '小于': 'Less Than',
  '小于等于': 'Less Than or Equal To',
  '介于': 'Between',
  // 同步工作流引擎 activiti_sync
  '同步': 'Sync',
  '不同步': 'Not Synced',
  // 删除状态 del_flag
  '已删除': 'Deleted',
  // Online图表展示模板 online_graph_display_template
  '单排布局': 'Single-column Layout',
  '组合布局': 'Combined Layout',
  '双排布局': 'Double-column Layout',
  'Tab风格': 'Tab Style',
  // 条件规则 rule_conditions
  '左模糊': 'Left Fuzzy',
  '右模糊': 'Right Fuzzy',
  '不等于': 'Not Equal',
  '等于': 'Equal',
  '自定义SQL表达式': 'Custom SQL Expression',
  '模糊': 'Fuzzy',
  '包含': 'Contains',
  // 发送消息类型 msgType
  '文本': 'Text',
  '富文本': 'Rich Text',
  // Online表单类型 cgform_table_type
  '附表': 'Sub-table',
  '主表': 'Main Table',
  '单表': 'Single Table',
  // 流程状态 bpm_status
  '待提交': 'To Be Submitted',
  '已作废': 'Voided',
  // 发布状态 send_status
  '未发布': 'Unpublished',
  // Online图表类型 online_graph_type
  '柱状图': 'Bar Chart',
  '饼图': 'Pie Chart',
  // 流程类型 bpm_process_type
  '测试流程': 'Test Process',
  '业务办理': 'Business Handling'
}
